import { useState } from 'react';
import { api } from '../api';
import { aiTipLabel } from '../copy';

export default function AiTip({ context, question }) {
  const [tip, setTip] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const askAi = async () => {
    setLoading(true);
    setError(false);
    try {
      const { content } = await api.sendAdvisorMessage([
        { role: 'user', content: `${context}\n\nQuestion: ${question}\n\nKeep your answer under 150 words. Be specific with numbers and program names.` }
      ]);
      setTip(content);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  if (tip) {
    return (
      <div className="bg-gradient-to-r from-teal/10 to-blue-900/10 border border-teal/20 rounded-xl p-4 space-y-2">
        <div className="flex items-center gap-2 text-xs text-teal font-bold uppercase tracking-wider">
          <span className="w-5 h-5 rounded-full bg-teal/20 flex items-center justify-center text-[10px]">AI</span>
          <span>{aiTipLabel}</span>
        </div>
        <p className="text-sm text-brand-ink/80 leading-relaxed">{tip}</p>
        <button onClick={() => setTip(null)} className="text-[10px] text-brand-ink/55 hover:text-brand-ink/70">Got it</button>
      </div>
    );
  }

  return (
    <button
      onClick={askAi}
      disabled={loading}
      className="w-full text-left bg-brand-ink/5 hover:bg-white/[0.06] border border-dashed border-brand-ink/10 hover:border-teal/30 rounded-xl p-3 transition group"
    >
      <div className="flex items-center gap-2">
        <span className="w-5 h-5 rounded-full bg-teal/10 flex items-center justify-center text-[10px] text-teal/70 group-hover:text-teal transition">AI</span>
        <span className="text-xs text-brand-ink/55 group-hover:text-brand-ink/70">
          {loading ? 'Thinking…' : error ? 'Something went wrong. Try again.' : question}
        </span>
      </div>
    </button>
  );
}
